import type { AccountSummary } from '@fruitful/types';

import { requestBuilder } from '../../../../http/RequestBuilder';
import { useRefetchHolisticSummaryMutationOptions } from '../useRefetchHolisticSummaryMutationOptions';

interface SetSpinwheelCreditCardQuilttAccountIdBody {
    userId: string;
    spinwheelAccountId: string;
    quilttAccountId?: string | null;
}

const useSetSpinwheelCreditCardQuilttAccountId = requestBuilder.mutation<
    AccountSummary | null,
    SetSpinwheelCreditCardQuilttAccountIdBody
>({
    endpoint:
        '/api/admin/holistic/accounts/spinwheel/credit-card/set-quiltt-account-id',
    method: 'PATCH',
});

export const useSetSpinwheelCreditCardQuilttAccountIdAndRefetch = (
    membershipId: string | null,
) => {
    const refetchHolisticSummaryMutationOptions =
        useRefetchHolisticSummaryMutationOptions(membershipId);

    const { mutateAsync } = useSetSpinwheelCreditCardQuilttAccountId(
        refetchHolisticSummaryMutationOptions,
    );

    const setSpinwheelCreditCardQuilttAccountIdAsync = async (
        body: SetSpinwheelCreditCardQuilttAccountIdBody,
    ) => {
        return await mutateAsync({
            body,
        });
    };

    return {
        setSpinwheelCreditCardQuilttAccountIdAsync,
    };
};
